<template>
  <button class="el-th-button"
          @click="handleClick"
          :disabled="buttonDisabled"
          :autofocus="autofocus"
          :type="nativeType"
          :class="[
      type ? 'el-th-button--' + type : '',
      buttonSize ? 'el-th-button--' + buttonSize : '',
      {
        'is-th-disabled': buttonDisabled,
      }
    ]">
    <i :class="icon"
       v-if="icon"></i>
    <span v-if="$slots.default">
      <slot></slot>
    </span>
  </button>
</template>
<script>
export default {
  name: 'ElButton',
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize () {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize () {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick (evt) {
      this.$emit('click', evt);
    }
  }
};
</script>
<style lang="scss">
@import url("./iconfont.css");
button.el-th-button {
  cursor: pointer;
  border: 1px solid transparent;
  outline: none;
  font-size: 16px;
  background: transparent;
  border-radius: 3px;
  &.el-th-button--edit,
  &.el-th-button--del {
    height: 24px;
    line-height: 24px;
    padding: 1px 6px;
    color: #4084f0;
  }
  &.el-th-button--edit:hover {
    border: 1px solid #4084f0;
    color: #4084f0;
    background: #ebf4f0;
  }
  &.el-th-button--del:hover {
    border: 1px solid #f86359;
    color: #f86359;
    background: #fffceb;
    i {
      color: #f86359;
    }
  }

  &.el-th-button--save,
  &.el-th-button--normal {
    height: 28px;
    line-height: 28px;
    padding: 1px 15px;
  }
  &.el-th-button--edit.is-th-disabled,
  &.el-th-button--del.is-th-disabled,
  &.el-th-button--del.is-th-disabled:hover {
    color: #cad0d7;
    background: transparent;
    border: 1px solid transparent;
    i {
      color: #cad0d7;
    }
  }

  &.el-th-button--normal,
  &.el-th-button--save {
    background: #1b9cff;
    color: #fff;
  }
  &.el-th-button--save:hover {
    background: #188ce5;
    color: #fff;
  }
  &.el-th-button--save.is-th-disabled,
  &.el-th-button--normal.is-th-disabled,
  &.el-th-button--normal.is-th-disabled:hover {
    background: #cad0d7;
    color: #fff;
    border: 1px solid #cad0d7;
  }
  &.el-th-button--normal {
    color: #5c79b0;
    border: 1px solid #a9c4df;
    background: #ebf4fe;
  }
  &.el-th-button--normal:hover {
    color: #fff;
    background: #1b9cff;
    border: 1px solid #1b9cff;
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/button/SecondaryButton.vue